import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessResponderSub } from "src/app/commons/kymw00/pless-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";

@Injectable()
export class OldLoginService extends PlessResponderSub {

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  execute(param: { userID: string, passWord: string }): void {
    const xml = `<pless version="1.0" author="PLESS Development Team">
     <req>
        <data>
          <parameter>
            <UserID>${param.userID}</UserID>
            <UserPassWord>${param.passWord}</UserPassWord>
            <DeleteFlag>0</DeleteFlag>
            <LockFlag>0</LockFlag>
          </parameter>
        </data>
      </req>
    </pless>`;

    this.send('oldLogin', xml);
  }

  success(_: any): void {
    console.log('logged into the current backend!');
  }
}
